// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CloseOutlineSvg from '@rsuite/icon-font/lib/action/CloseOutline';
var CloseOutline = createSvgIcon({
  as: CloseOutlineSvg,
  ariaLabel: 'close outline',
  category: 'action',
  displayName: 'CloseOutline'
});
export default CloseOutline;